<script setup lang="ts">
    import { useEditCoachingFormStore } from '@/js/stores/edit-coaching-form';
    import CheckboxInput from '../CheckboxInput.vue';
    import FormGroup from '../FormGroup.vue';
    import TextareaInput from '../TextareaInput.vue';
    import { watch } from 'vue';
    import InputLabel from '../InputLabel.vue';
    import { storeToRefs } from 'pinia';
    import { __ } from '@/js/stores/expressions';

    const { formDraft } = storeToRefs(useEditCoachingFormStore());

    watch(
        () => formDraft.value?.useAction,
        () => {
            if (!formDraft.value?.useAction) {
                delete formDraft.value?.action;
            } else if (!formDraft.value?.action) {
                formDraft.value.action = '';
            }
        }
    );
</script>

<template>
    <div v-if="formDraft">
        <FormGroup :help-hint="__('explain', { label: __('coaching-form-action-header') })">
            <template #header>
                {{ __('coaching-form-action-header') }}
            </template>
            <template #help>
                <p>
                    {{ __('coaching-form-action-help-text') }}
                </p>
            </template>
            <CheckboxInput id="form-action" v-model="formDraft.useAction">
                {{ __('coaching-form-use-action') }}
            </CheckboxInput>
        </FormGroup>
        <div v-if="formDraft.useAction" class="mt-4 bg-gray-extralight p-6 rounded-md">
            <InputLabel for="form-action-description">
                {{ __('description') }}
            </InputLabel>
            <TextareaInput
                id="form-action-description"
                v-model="formDraft.action"
                validation-key="action"
            />
        </div>
    </div>
</template>
